import { CircularProgress } from '@mui/material';
import { Download } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';

interface AuditReportHistoryPreviewProps {
  htmlContent: string | null;
  loading: boolean;
}

export function AuditReportHistoryPreview({ htmlContent, loading }: AuditReportHistoryPreviewProps) {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);

  // Sanitize HTML content to remove sourcemap references that cause browser warnings
  const sanitizedHtmlContent = htmlContent
    ? htmlContent.replace(/\/\*#\s*sourceMappingURL=.*?\*\//g, '').replace(/\/\/#\s*sourceMappingURL=.*/g, '')
    : null;

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `Bericht_${new Date().toLocaleDateString('de-DE')}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
    `,
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <CircularProgress />
      </div>
    );
  }

  if (!sanitizedHtmlContent) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500">
        {t('route.dpo.auditReport.selectOrCreate')}
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="p-4 border-b flex justify-end">
        <button
          onClick={handlePrint}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-2"
        >
          <Download size={16} />
          PDF herunterladen
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-6 bg-white">
        <div
          ref={contentRef}
          dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
          style={{ visibility: sanitizedHtmlContent ? 'visible' : 'hidden' }}
        />
      </div>
    </div>
  );
}
